"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable max-len */
var _default = {
  fn: function fn(value, _ref) {
    var emailPattern = _ref.emailPattern;
    return !value.match(emailPattern);
  },
  errorMessageId: 'forms.error.invalidEmail',
  emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};
exports["default"] = _default;